var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "container-fluid" }, [
    _c(
      "div",
      { staticClass: "row" },
      [
        _c("layout-left-auth"),
        _vm._v(" "),
        _c("div", { staticClass: "col-md-5" }, [
          _c(
            "div",
            {
              staticClass:
                "container h-full d-flex align-items-center justify-content-center flex-column"
            },
            [
              _vm._m(0),
              _vm._v(" "),
              _c(
                "form",
                {
                  staticClass: "new-auth-form",
                  attrs: { autocomplete: "no" },
                  on: {
                    submit: function($event) {
                      $event.preventDefault()
                      return _vm.send($event)
                    },
                    keydown: function($event) {
                      _vm.clearError($event)
                    }
                  }
                },
                [
                  _c("div", { staticClass: "material-textfield" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.user.email,
                          expression: "user.email"
                        }
                      ],
                      attrs: {
                        id: "email",
                        name: "email",
                        type: "text",
                        placeholder: " ",
                        autofocus: ""
                      },
                      domProps: { value: _vm.user.email },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(_vm.user, "email", $event.target.value)
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c("label", [_vm._v("Email")])
                  ]),
                  _vm._v(" "),
                  _c("error-field", {
                    staticClass: "material-errors",
                    attrs: { errors: _vm.errors, field: "email" }
                  }),
                  _vm._v(" "),
                  _c("error-field", {
                    staticClass: "material-errors",
                    attrs: { errors: _vm.errors, field: "exception" }
                  }),
                  _vm._v(" "),
                  _c("error-field", {
                    staticClass: "material-errors",
                    attrs: { errors: _vm.errors, field: "credentials" }
                  }),
                  _vm._v(" "),
                  _c("input", {
                    staticClass:
                      "btn btn-primary login-button reset-btn hover-btn-bg",
                    attrs: {
                      type: "submit",
                      value: "Reset password",
                      disabled: _vm.errors.any()
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c("div", { staticClass: "row" }, [
                _c(
                  "div",
                  { staticClass: "col" },
                  [
                    _c(
                      "router-link",
                      { staticClass: "back-link", attrs: { to: "/login" } },
                      [_vm._v("Go back to login")]
                    )
                  ],
                  1
                )
              ])
            ]
          )
        ])
      ],
      1
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "row d-flex flex-column text-center align-items-center" },
      [
        _c("img", {
          staticClass: "logo-mobile-auth d-sm-none",
          attrs: { src: require("../../assets/img/blue-logo.png") }
        }),
        _vm._v(" "),
        _c("div", { staticClass: "forgot-title" }, [
          _vm._v("Forgot your password?")
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "forgot-undertitle" }, [
          _vm._v("Enter your email to reset the password")
        ])
      ]
    )
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-10a52436", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-10a52436","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/auth/ForgotPassword.vue
// module id = null
// module chunks = 